import { DeleteOutlined } from '@ant-design/icons';
import { theme } from 'antd';

const ClearIcon = () => {
  const { token } = theme.useToken();
  return (
    <DeleteOutlined
      style={{
        color: token.colorError,
        fontSize: 16,
        opacity: 0.8,
        transition: 'opacity 0.2s, transform 0.2s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = '1';
        e.currentTarget.style.transform = 'scale(1.2)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = '0.65';
        e.currentTarget.style.transform = 'scale(1)';
      }}
    />
  );
};

export default ClearIcon;
